/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import turf from '@turf/circle';

export function aggregateData(data, coords) {
  console.log('coords & data ', coords, data);

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  function getVoteListByRadius(r) {
    const ag = [];
    data.forEach((obj) => {
      const distance = getDistanceFromLatLonInKm(
        coords[1],
        coords[0],
        obj.la,
        obj.lo,
      );
      // console.log('distance ', distance);
      if (distance < r) {
        ag.push(obj);
      }
    });
    return ag.map((obj) => {
      return { bubID: `bub-${obj.n.replace(' ', '')}`, ...obj };
    });
  }

  function uniq(items, key) {
    const set = {};
    return items.filter((item) => {
      const k = key ? key.apply(item) : item;
      // eslint-disable-next-line no-return-assign
      return k in set ? false : (set[k] = true);
    });
  }

  let dataRadius = getVoteListByRadius(2);
  console.log('dataRadius ', dataRadius);

  // get parties
  const partiesAll = dataRadius.map((obj) => obj.pn);
  const pollingPlacesAll = dataRadius.map((obj) => {
    return [obj.lo, obj.la];
  });

  const parties = Array.from(new Set(partiesAll));
  console.log('parties ', parties);

  const pollingPlaces = uniq(pollingPlacesAll, [].join);
  console.log('pollingplaces ', pollingPlaces);

  let partyData = parties.map((party) => {
    // need to grab accronym also
    const found = data.find((obj) => {
      return party === obj.pn;
    });
    return {
      p: party,
      pa: found.pa,
      votes: 0,
    };
  });

  const ppData = pollingPlaces.map((c) => {
    return {
      point: c,
      votes: 0,
    };
  });

  partyData.forEach((obj) => {
    obj.votes = dataRadius.reduce((prev, cur) => {
      if (cur.pn === obj.p) {
        return (prev += parseFloat(cur.vo));
      }
      return prev;
    }, 0);
  });

  ppData.forEach((obj) => {
    obj.votes = dataRadius.reduce((prev, cur) => {
      if (cur.lo === obj.point[0] && cur.la === obj.point[1]) {
        return (prev += parseFloat(cur.vo));
      }
      return prev;
    }, 0);
  });

  // create geo for polling places
  const geoPP = {
    type: 'FeatureCollection',
    features: [],
  };

  ppData.forEach((obj) => {
    const options = {
      steps: 8, //  or look at file size based on 10
      units: 'kilometers',
      properties: obj,
    };
    const feature = turf(obj.point, 0.05, options);
    geoPP.features.push(feature);
  });

  // add percentages to party data
  const totalVotes = partyData.reduce((prev, cur) => {
    return prev + cur.votes;
  }, 0);

  partyData.forEach((obj) => {
    obj.perc = obj.votes / totalVotes;
  });

  partyData = partyData.sort((a, b) => {
    return b.votes - a.votes;
  });

  dataRadius = dataRadius.filter((obj) => {
    return obj.vo > 0;
  });

  console.log('partyData ', partyData);
  console.log('ppData ', geoPP);
  console.log('dataRadius ', dataRadius);

  return {
    partyData,
    geoPP,
    dataRadius,
    totalVotes,
  };
}
